import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import { Search } from 'lucide-react';
import classes from "./User.module.css"
import plus from "../../../../../Assets/plus.svg"
import ReportBackground from "../../../../../Assets/report.svg"
import run from "../../../../../Assets/run.svg"
import MailLogo from "../../../../../Assets/mail.svg"
import PrintLogo from "../../../../../Assets/print.svg"
import DownloadLogo from "../../../../../Assets/down.svg"
import BackLogo from "../../../../../Assets/back.svg"
import RotatingLogo from '../../../../../Assets/rotating-logo.png'
import EyeIcon from "../../../../../Assets/new-eye.svg"
import DeleteIcon from "../../../../../Assets/new-delete.svg"
import PencilIcon from "../../../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../../../Accoungting/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../../../Components/Styles/API/API";
import { useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import download from "../../../../../Assets/download1.svg"
import upload from "../../../../../Assets/upload.svg"
import logo from "../../../../../Assets/rotating-logo.png";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { FaFilePdf } from "react-icons/fa";
import { FaFileExcel } from "react-icons/fa";

const User = () => {
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [savingsLoading, setSavingsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [cashbook, setCashbook] = useState([]);
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);

  // Continent and Region Filter States
  const [selectedContinent, setSelectedContinent] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [continents, setContinents] = useState([]);
  const [regions, setRegions] = useState([]);
  const [contLoading, setContLoading] = useState(false);
  const [regionLoading, setRegionLoading] = useState(false);

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const current = await localStorage.getItem('currentMonth');
      const admins = await localStorage.getItem('admin');
      const continentName = await localStorage.getItem('continent');
      const regionName = await localStorage.getItem('region');
      const provinceName = await localStorage.getItem('province');

      if (value !== null) {
        setBearer(value);
      }

      if (value1 !== null) {
        setUser(value1);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  // Add the missing formatDate function
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  // Fetch continents for React Select
  const fetchContinents = async () => {
    setContLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/continents`, { headers });
      const contList = response.data?.data;
      const options = contList.map((item) => ({
        label: item.description,
        value: item.id,
      }));

      // Add "All" option to continents
      const continentsWithAll = [
        { label: "All Continents", value: "all" },
        ...options
      ];

      setContinents(continentsWithAll);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        console.error("Error fetching continents:", error);
        setContinents([{ label: "All Continents", value: "all" }]);
      }
    } finally {
      setContLoading(false);
    }
  };

  // Fetch regions based on selected continent
  const fetchRegions = async (continentId) => {
    setRegionLoading(true);
    try {
      let regionsData = [];

      // If "All" is selected or no continent selected, show empty regions
      if (continentId === 'all' || !continentId) {
        setRegions([{ label: "All Regions", value: "all" }]);
        return;
      }

      const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${continentId}`, { headers });
      regionsData = response.data?.data?.regions || response.data?.data || [];
      const options = regionsData.map((item) => ({
        label: item.description,
        value: item.id,
      }));

      // Add "All" option to regions
      const regionsWithAll = [
        { label: "All Regions", value: "all" },
        ...options
      ];

      setRegions(regionsWithAll);
    } catch (error) {
      console.error("Error fetching regions:", error);
      setRegions([{ label: "All Regions", value: "all" }]);
    } finally {
      setRegionLoading(false);
    }
  };

  // Filter handlers
  const handleContinentChange = (selectedOption) => {
    setSelectedContinent(selectedOption);
    setSelectedRegion(null);

    if (selectedOption && selectedOption.value !== 'all') {
      fetchRegions(selectedOption.value);
    } else {
      setRegions([{ label: "All Regions", value: "all" }]);
    }
  };

  const handleRegionChange = (selectedOption) => {
    setSelectedRegion(selectedOption);
  };

  // Fetch users data with pagination and filtering
  const fetchUsers = async (page = 1) => {
    setLoading(true);
    try {
      let url = `${BASE_URL}/users/fetch-all`;
      let params = {
        page,
        per_page: entriesPerPage,
        ...(searchTerm && { search: searchTerm })
      };

      // If continent or region filters are selected (and not "All"), use the filter endpoint
      if ((selectedContinent && selectedContinent.value !== 'all') || (selectedRegion && selectedRegion.value !== 'all')) {
        url = `${BASE_URL}/users/get-by-filter`;

        // Build filter parameters
        const filterParams = {
          page,
          per_page: entriesPerPage,
          ...(searchTerm && { search: searchTerm })
        };

        // Add continent filter if selected and not "All"
        if (selectedContinent && selectedContinent.value !== 'all') {
          filterParams.continent_id = selectedContinent.value;
        }

        // Add region filter if selected and not "All"
        if (selectedRegion && selectedRegion.value !== 'all') {
          filterParams.region_id = selectedRegion.value;
        }

        params = filterParams;
      }

      const response = await axios.get(url, {
        headers,
        params
      });

      const data = response.data?.data;
      if (data) {
        // Handle different response structures
        const usersData = data.data || data.users || data || [];
        setTableData(usersData);
        setTotalEntries(data.total || usersData.length);
        setTotalPages(data.last_page || 1);
        setCurrentPage(data.current_page || page);
        console.log("Users data:", usersData);
      } else if (response.data?.users) {
        const usersData = response.data.users;
        setTableData(usersData);
        setTotalEntries(usersData.length);
        setTotalPages(1);
        setCurrentPage(1);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      setTableData([]);
      Swal.fire({
        title: "Error",
        text: "Failed to fetch users data",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  // Export to Excel function
  const handleExportExcel = () => {
    const dataToExport = displayedData.length > 0 ? displayedData : tableData;

    if (dataToExport.length === 0) {
      Swal.fire({
        title: "No Data",
        text: "There is no data to export.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(dataToExport.map(item => ({
      "Name": item.name || "",
      "Email": item.email || "",
      "Phone Number": item.phone_number || "",
      "User Type": item.type_name || "",
      "Station": item.display_name || "",
      "Created Date": formatDate(item.created_at),
    })));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
    XLSX.writeFile(workbook, "users.xlsx");
  };

  // Export to PDF function
  const handleExportPDF = () => {
    const dataToExport = displayedData.length > 0 ? displayedData : tableData;

    if (dataToExport.length === 0) {
      Swal.fire({
        title: "No Data",
        text: "There is no data to export.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Users List", 14, 15);
    doc.setFontSize(10);
    doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 22);

    const tableData = dataToExport.map(item => [
      item.name || "",
      item.email || "",
      item.phone_number || "",
      item.type_name || "",
      item.display_name || "",
      formatDate(item.created_at),
    ]);

    doc.autoTable({
      head: [['Name', 'Email', 'Phone Number', 'User Type', 'Station', 'Created Date']],
      body: tableData,
      startY: 30,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [66, 139, 202] }
    });

    doc.save("users.pdf");
  };

  useEffect(() => {
    if (bearer) {
      fetchUsers();
      fetchContinents();
      // Initialize regions with "All" option
      setRegions([{ label: "All Regions", value: "all" }]);
    }
  }, [bearer]);

  // Auto-fetch users when filters change
  useEffect(() => {
    if (bearer) {
      setCurrentPage(1); // Reset to first page when filters change
      fetchUsers(1);
    }
  }, [selectedContinent, selectedRegion, bearer]);

  // Filter data based on search term
  const filteredData = tableData.filter(item =>
    item.name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
    item.email?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
    item.phone_number?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
    item.type_name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
    item.display_name?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const startIndex = (currentPage - 1) * entriesPerPage + 1;
  const endIndex = Math.min(currentPage * entriesPerPage, totalEntries);
  const displayedData = filteredData;

  const handleShow1 = (loan) => {
    setLoanCode(loan.code);
    setLoanDescription(loan.description);
    setSelectedReportTo(loan.reportTo);
    setShow1(true);
  };

  const handleClose1 = () => setShow1(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  // Original download function (CSV)
  const handleDownload = () => {
    const dataToExport = displayedData.length > 0 ? displayedData : tableData;

    if (dataToExport.length === 0) {
      Swal.fire({
        title: "No Data",
        text: "There is no data to export.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const csvContent = [
      ["Name", "Email", "Phone Number", "User Type", "Station", "Created Date"],
      ...dataToExport.map(d => [
        d.name || "",
        d.email || "",
        d.phone_number || "",
        d.type_name || "",
        d.display_name || "",
        formatDate(d.created_at),
      ])
    ].map(e => e.join(",")).join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "users.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleMail = () => alert("Mail clicked!");
  const handlePrinter = () => window.print();
  const handlePrint = () => window.print();

  // Pagination handlers
  const handlePrevPage = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1;
      setCurrentPage(newPage);
      fetchUsers(newPage);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
      fetchUsers(newPage);
    }
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
    fetchUsers(page);
  };

  const formattedTotalEntries = totalEntries.toLocaleString();

  // React Select styles (same as in ManageUser component)
  const selectStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%',
      fontSize: 12,
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "36px",
      fontSize: 12,
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: 12,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
      color: "#111827",
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: "300px",
      overflowY: "auto",
      fontSize: 12,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  // Pagination component
  const renderPagination = () => {
    const pages = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          className={`${classes.pageButton} ${currentPage === i ? classes.activePage : ''}`}
          onClick={() => handlePageClick(i)}
        >
          {i}
        </button>
      );
    }

    return (
      <div className={classes.paginationContainer}>
        <div className={classes.paginationControls}>
          <button
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            className={classes.pageButton}
          >
            Previous
          </button>

          {pages}

          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className={classes.pageButton}
          >
            Next
          </button>

          <span className={classes.pageText}>
            Displaying {startIndex} - {endIndex} of {formattedTotalEntries}
          </span>
        </div>
      </div>
    );
  };

  const tableRef = useRef(null);

  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.backTxt}>
          <img src={BackLogo} alt="back" className={classes.iconBtn} onClick={() => navigate(-1)} />
        </div>

        <div style={{ marginTop: 12 }} />

        <div className={classes.topNavBars}>
          <div className={classes.filterRow}>
            <div className={classes.filterInputs}>
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Continent:</label>
                <Select
                  onChange={handleContinentChange}
                  options={continents}
                  value={selectedContinent}
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
              </div>

              {/* Region Filter */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Region:</label>
                <Select
                  onChange={handleRegionChange}
                  options={regions}
                  value={selectedRegion}
                  isDisabled={!selectedContinent || selectedContinent?.value === 'all'}
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
              </div>
            </div>

          </div>
          <div className={classes.searchInputWrapper}>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={classes.searchInput}
              placeholder="Search users..."
            />
            <Search className={classes.searchIcon} size={16} />
          </div>
          {/* Right side: Export Buttons */}
        </div>

        <div style={{ marginTop: 24 }} />

        <div className={classes.containere}>
          {/* Icon Bar with all export options */}
          <div className={classes.iconbars}>
            <div className={classes.iconbarss}>
              <div className={classes.iconbar} onClick={handleMail} style={{ cursor: "pointer" }}>
                <img src={MailLogo} alt="icon1" className={classes.iconBtns} />
              </div>
              <div className={classes.iconbar} onClick={handlePrinter} style={{ cursor: "pointer" }}>
                <img src={PrintLogo} alt="icon2" className={classes.iconBtns} />
              </div>
              <div className={classes.iconbar} onClick={handleDownload} style={{ cursor: "pointer" }}>
                <img src={DownloadLogo} alt="icon3" className={classes.iconBtns} />
              </div>
              {/* PDF and Excel as React Icons with colors */}
              <div className={classes.iconbar} onClick={handleExportPDF} style={{ cursor: "pointer" }}>
                <FaFilePdf size={20} color="#FF0000" className={classes.iconBtns} />
              </div>
              <div className={classes.iconbar} onClick={handleExportExcel} style={{ cursor: "pointer" }}>
                <FaFileExcel size={20} color="#217346" className={classes.iconBtns} />
              </div>
            </div>
          </div>

          <div className={classes.tableContainer}>
            <table className={classes.tableTable}>
              <thead className={classes.tableHeader}>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>User Type</th>
                  <th>Station</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  Array.from({ length: 7 }).map((_, index) => (
                    <tr key={`skeleton-${index}`}>
                      <td className={classes.textby}><Skeleton height={20} /></td>
                      <td className={classes.textby}><Skeleton height={20} /></td>
                      <td className={classes.textby}><Skeleton height={20} /></td>
                      <td className={classes.textby}><Skeleton height={20} /></td>
                      <td className={classes.textby}><Skeleton height={20} /></td>
                      <td className={classes.textby}><Skeleton height={20} /></td>
                    </tr>
                  ))
                ) : displayedData.length > 0 ? (
                  displayedData.map((item, index) => (
                    <tr key={item.id || index}>
                      <td className={classes.textby}>{startIndex + index}</td>
                      <td className={classes.textby}>
                        {item.name || 'N/A'}
                      </td>
                      <td className={classes.textby}>
                        {item.email || 'N/A'}
                      </td>
                      <td className={classes.textby}>
                        {item.phone_number || 'N/A'}
                      </td>
                      <td className={classes.textby}>
                        {item.type_name || 'N/A'}
                      </td>
                      <td className={classes.textby}>
                        {item.display_name || 'N/A'}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center p-4">
                      {loading ? "Loading users..." :
                        searchTerm ? "No users found matching your search" :
                          "No users available"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {totalPages > 1 && renderPagination()}
          </div>
        </div>
      </div>

      {savingsLoading && (
        <div className={classes.overlay}>
          <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
    </div>
  );
};

export default User;